import React from 'react'
import { Pressable } from 'react-native'
import { tv } from 'tailwind-variants'

import * as checkmarkWhite from '@ui-kit/assets/images/src/icons/xsmall/checkmarkWhite_14x11.svg'
import Icon from '@ui-kit/components/SvgIcon'

const checkbox = tv({
  base: 'mr-1.5 flex h-6 w-6 flex-col items-center justify-center rounded-lg border border-grey-500 bg-white',
  variants: {
    isChecked: {
      true: 'border-black bg-black',
    },
    hasError: {
      true: 'border-error',
    },
  },
})

export const Checkbox = ({ isChecked, onPress, hasError, testID }: any) => {
  return (
    <Pressable
      className={checkbox({
        isChecked,
        hasError,
      })}
      testID={testID}
      onPress={() => onPress(!isChecked)}
    >
      {isChecked === true ? <Icon imgSrc={checkmarkWhite.default.src} /> : null}
    </Pressable>
  )
}
